<template>
    <div class="loginbg">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="/static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <div class="form-group">
                                <label for="exampleInputEmail1">Email address</label>
                                <input v-model="username" type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter email address">
                                <!-- <font class="text-danger" v-html="usernameError"></font> -->
                                <div class="c-error">{{usernameError}}</div>
                            </div>
                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input v-model="password" type="password" class="form-control" id="exampleInputPassword1" placeholder="Enter password">
                                <!-- <font class="text-danger" v-html="passwordError"></font> -->
                                <div class="c-error">{{passwordError}}</div>
                            </div>


                            <div class="c-error">{{error}}</div>
                            <!-- <div class="form-check">
                                <label class="checkbox-inline checkbox-bootstrap checkbox-lg">
                                    <input type="checkbox">
                                    <span class="checkbox-placeholder"></span>
                                    Remember me
                                </label>
                            </div> -->

                            <button v-on:click.prevent="login()" type="submit" class="btn btn-primary">Login</button>
                            <!-- <div style="float: right; margin-top: 40px; display: flex; align-items: center; gap: 6px;">
                                <a :href="forgot_pass_url" target="_blank" style="float: none; margin: 0;">Forgot password?</a>
                                <span style="color: #29a3b0;">|</span>
                                <a :href="sign_up_url" target="_blank" style="float: none; margin: 0;">Sign Up</a>
                            </div> -->
                            <a :href="sign_up_url" target="_blank">Sign Up</a>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {HTTP} from '../http-common';
    import EventBus from './event-bus';
    import moment from 'moment';

    Vue.use(VueGoodTable);

    var self;
    export default {
        name: 'Login',
        data() {
            return {
                username : '',
                password : '',
                error: '',
                // Frontend Errors
                usernameError : '',
                passwordError : '',
                forgot_pass_url: '',
                sign_up_url: '',
                browserTimeZone : ""
            }

        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self = this;

            // $("#exampleInputEmail1").on('keyup', function () {
            //     self.usernameError = '';
            // });
            // $("#exampleInputPassword1").on('keyup', function () {
            //     self.passwordError = '';
            // });
            // $("#exampleInputPassword1").on('change', function () {
            //     self.passwordError = '';
            // });
            $("input").keypress(function(e) {
              if (e.keyCode === 13) {
                if (e.target.id == "exampleInputEmail1" || e.target.id == "exampleInputPassword1") {
                  e.preventDefault();
                //   console.log("Enter Triggered");
                  self.login();
                }
              }
            });

            self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
            self.sign_up_url = process.env.SIGN_UP_HR_URL;
            //  + "?identify=" + window.location.href;
            self.browserTimeZone = moment.tz.guess();
        },
        methods: {
            validation: function () {
                var checked = true;

                if (!self.username) {
                    self.usernameError = "Email address Required.";
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.username)) {
                    self.usernameError = 'Please Enter Valid Email address';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.password) {
                    self.passwordError = "Password Required.";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            login: function () {
                self.usernameError = '';
                self.passwordError = '';
                self.error = '';
                // self.validation();
                if (self.validation()) {
                    var data = {
                        username : self.username,
                        password : self.password,
                    }
                    HTTP.post('/login',data)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                window.localStorage.setItem('browserTimeZone', self.browserTimeZone);
                                window.localStorage.setItem("api_token", response.data.content.api_token);
                                window.localStorage.setItem("user_obj", JSON.stringify(response.data.content.user_obj));

                                let userCurrentLocation = JSON.parse(localStorage.getItem("user_obj"))['user_current_location'];
                                let current_location_view = "";

                                if (userCurrentLocation === "primary") {
                                    current_location_view = "front_end";
                                } else if (userCurrentLocation === "secondary") {
                                    current_location_view = "will_call";
                                }
                                window.localStorage.setItem("current_location_view", current_location_view);
                                //self.$router.push("/closeticket");
                                self.$router.push("/");

                                var userObj = JSON.parse(localStorage.getItem("user_obj"));
                                if (userObj != null) {
                                    EventBus.$emit('login-user-info', userObj.username, userObj.first_name, userObj.last_name, userObj.location_name, userObj.will_call_location_name);
                                }
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        })
                }
            },

        }
    }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue